import * as R from 'ramda';
import React from 'react';
export const render = R.curryN(2, React.createElement);
export default render;
